import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import {
  fetchInvoicePreviewAction,
  clearInvoicePreview,
} from "../slices/invoicePreviewSlice";
import { FetchInvoicePreviewRequest } from "@/api/fetchInvoicePreview/types";

export function useInvoicePreview() {
  const dispatch = useDispatch();
  const { previews, loadingByBatch, error } = useSelector(
    (state: RootState) => state.invoicePreview,
  );

  const fetchPreview = useCallback(
    (requestData: FetchInvoicePreviewRequest) => {
      dispatch(fetchInvoicePreviewAction(requestData));
    },
    [dispatch],
  );

  const getPreview = useCallback(
    (batchReference: string) => {
      return previews[batchReference] || null;
    },
    [previews],
  );

  const isLoading = useCallback(
    (batchReference: string) => {
      return loadingByBatch[batchReference] || false;
    },
    [loadingByBatch],
  );

  const clearPreview = useCallback(
    (batchReference: string) => {
      dispatch(clearInvoicePreview(batchReference));
    },
    [dispatch],
  );

  return {
    previews,
    loadingByBatch,
    error,
    fetchPreview,
    getPreview,
    isLoading,
    clearPreview,
  };
}
